import { DataGrid, GridColumns } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import ForecastDiarizado from "../../components/classes/ForecastDiarizado";
import ForecastDiarizadoEstoqueConsumido from "../../components/classes/ForecastDiarizadoEstoqueConsumido";
import ForecastDiarizadoDataset from "../../components/data/ForecastDiarizadoDataSet";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function ForecastDiarioModalGrid(props: ForecastDiarioGridModalPropsTypes) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);

  const [forecastDiarizadoEstoqueConsumido, setForecastDiarizadoEstoqueConsumido] = useState<
    ForecastDiarizadoEstoqueConsumido[]
  >([]);
  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = createColumns();

  const dataForecastDiarizado: ForecastDiarizadoDataset = new ForecastDiarizadoDataset();

  useEffect(() => {
    if (props.forecastsDiarizados) {
      fetchData(props.forecastsDiarizados);
    }
  }, [props.forecastsDiarizados]);

  async function fetchData(forecastsDiarizados: ForecastDiarizado[]) {
    let forecastDiarizadoEstoqueConsumidoArr: ForecastDiarizadoEstoqueConsumido[] = [];
    for await (const item of forecastsDiarizados) {
      let forecastDiarizadoEstoque = new ForecastDiarizadoEstoqueConsumido(
        item.id,
        item.codigoFornecedorSap,
        item.numeroContrato,
        parseInt(item.idSku),
        parseInt(item.centro),
        item.quantidade,
        item.anoMesRef,
        item.dia
      );
      await dataForecastDiarizado
        .obterPercentualConsumido(forecastDiarizadoEstoque)
        .then((percentual) => {
          forecastDiarizadoEstoque.setPercentualConsumido(percentual);
          forecastDiarizadoEstoqueConsumidoArr.push(forecastDiarizadoEstoque);
        });
    }
    setForecastDiarizadoEstoqueConsumido(forecastDiarizadoEstoqueConsumidoArr);
    fillTable(forecastDiarizadoEstoqueConsumidoArr);
    setLoading(false);
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: "#",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "codigoFornecedorSap",
        headerName: t("pages.dailyForecast.text.sapSupplierCode"),
        minWidth: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "numeroContrato",
        headerName: t("common.contractNumber"),
        type: "string",
        minWidth: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "codigoSku",
        headerName: t("common.sku"),
        type: "string",
        minWidth: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centro",
        headerName: t("common.center"),
        type: "string",
        minWidth: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
      },

      {
        field: "percentualConsumido",
        headerName: t("common.percentageConsumed"),
        type: "string",
        minWidth: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <p>{item.row.percentualConsumido}%</p>;
        },
      },
      {
        field: "quantidade",
        headerName: t("common.quantity"),
        type: "string",
        minWidth: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "dia",
        headerName: t("common.day"),
        type: "string",
        minWidth: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <p>{new Date(item.row.dia).toLocaleDateString("pt-BR")}</p>;
        },
      },
    ];
    return cols;
  }

  function fillTable(dados: ForecastDiarizadoEstoqueConsumido[]) {
    let gridData: Data = [];
    dados.forEach((item: ForecastDiarizadoEstoqueConsumido) => {
      gridData.push(JSON.parse(ForecastDiarizadoEstoqueConsumido.toJson(item)));
    });
    setRows(gridData);
  }

  return (
    <>
      <div className="divFlow">
        <div style={{ height: "50vh", minWidth: "100%" }}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
          />
        </div>
      </div>
    </>
  );
}

interface ForecastDiarioGridModalPropsTypes {
  forecastsDiarizados?: ForecastDiarizado[];
}
